module.exports = __webpack_public_path__ + "img/closejd.9e47ab01.svg";